import router from "src/routes/routes";
import { createCrudService } from "./crudFactory";

export const nonServiceCodesService = createCrudService("non_service_codes", [], router);